export const ADSENSE_SCRIPT_ID = "tacklefour-adsense";

export const ADSENSE_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_ADSENSE_CLIENT_ID?.trim() || "ca-pub-1985030212294751";

export type AdPlacement =
  | "dashboard"
  | "history"
  | "leaderboard"
  | "competition"
  | "achievements"
  | "newsFeed"
  | "newsStory";

const AD_SLOTS: Record<AdPlacement, string | undefined> = {
  dashboard: import.meta.env.VITE_GOOGLE_ADSENSE_SLOT_DASHBOARD?.trim(),
  history: import.meta.env.VITE_GOOGLE_ADSENSE_SLOT_HISTORY?.trim(),
  leaderboard: import.meta.env.VITE_GOOGLE_ADSENSE_SLOT_LEADERBOARD?.trim(),
  competition: import.meta.env.VITE_GOOGLE_ADSENSE_SLOT_COMPETITION?.trim(),
  achievements: import.meta.env.VITE_GOOGLE_ADSENSE_SLOT_ACHIEVEMENTS?.trim(),
  newsFeed: import.meta.env.VITE_GOOGLE_ADSENSE_SLOT_NEWS_FEED?.trim(),
  newsStory: import.meta.env.VITE_GOOGLE_ADSENSE_SLOT_NEWS_STORY?.trim(),
};

export interface AdEligibilityInput {
  authLoading: boolean;
  isAuthenticated: boolean;
  userLoading: boolean;
  adsEnabled?: boolean;
}

export interface AdEligibility {
  isResolved: boolean;
  shouldShowAds: boolean;
}

const ADVERTISING_EXCLUDED_PATHS = ["/login", "/profile", "/onboarding", "/admin", "/privacy"];

/**
 * Fail closed for authenticated users: if their profile cannot be resolved, do
 * not load advertising until the subscription entitlement is known.
 */
export function resolveAdEligibility({
  authLoading,
  isAuthenticated,
  userLoading,
  adsEnabled,
}: AdEligibilityInput): AdEligibility {
  const isResolved = !authLoading && (!isAuthenticated || !userLoading);
  const shouldShowAds = isResolved && (!isAuthenticated || adsEnabled === true);

  return { isResolved, shouldShowAds };
}

export function isAdSenseConfigured(): boolean {
  return /^ca-pub-\d+$/.test(ADSENSE_CLIENT_ID);
}

export function getAdSenseSlot(placement: AdPlacement): string | null {
  const slot = AD_SLOTS[placement];
  return slot && /^\d+$/.test(slot) ? slot : null;
}

export function isAdvertisingSupportedPath(pathname: string): boolean {
  return !ADVERTISING_EXCLUDED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}
